import React from "react";
import { motion } from "framer-motion";
import { needCategories, needProducts } from "../data/products";
import NeedProductCard from "./NeedProductCard";

export default function ShopByNeedSection({ refProp, onViewProduct }) {
  return (
    <section className="shop-by-need" ref={refProp} id="shop-by-need">
      <div className="container">
        <motion.div
          className="shop-by-need-header"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="shop-by-need-title">Who are you shopping for?</h2>
          <p className="shop-by-need-subtitle">Find what you need on one click</p>
        </motion.div>

        <div className="shop-by-need-stack">
          {needCategories.map((cat, sectionIndex) => {
            const items = needProducts[cat.id] ?? [];

            return (
              <motion.section
                key={cat.id}
                className="shop-by-need-category-block"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: sectionIndex * 0.05 }}
              >
                <div className="shop-by-need-category-header">
                  <h3 className="shop-by-need-category-title">{cat.label}</h3>
                  {cat.tagline && (
                    <p className="shop-by-need-category-tagline">{cat.tagline}</p>
                  )}
                </div>

                {items.length > 0 ? (
                  <div className="shop-by-need-items-grid">
                    {items.map((product) => (
                      <NeedProductCard
                        key={product.id}
                        product={product}
                        onView={onViewProduct}
                      />
                    ))}
                  </div>
                ) : (
                  <p className="shop-by-need-panel-placeholder">
                    Products for this category will be listed here soon.
                  </p>
                )}
              </motion.section>
            );
          })}
        </div>
      </div>
    </section>
  );
}
